import { jobOpportunitySelector } from "./selector";
import DropDown from "../common/SearchableSelect";
import { useSelector, useDispatch } from "react-redux";
import { setCovidInfo,updatecovidVaccination } from "./action";
import MultiSelect from "../common/TextField/dropDown";
import { useEffect,useRef } from "react";
import { setResetDropdown } from "./slice";

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
    const { masterData, covidVaccinationStatus,selectedOption,resetDropdown } = useSelector(jobOpportunitySelector);
    const {newPost,fromTemplate,createTemplate,editJobPost} = selectedOption
    const dispatch = useDispatch();
     const vaccineRef = useRef();


    const updateCovidStatus = (target) => {
        const value = target.value;
        const action = target.action || 'add';
        dispatch(updatecovidVaccination(value, action));
    };
    useEffect(() => {
        if(newPost|| fromTemplate || createTemplate ){
            if(resetDropdown){
                vaccineRef.current.resetSelectedValues();
                dispatch(setResetDropdown(false))
            }
        }
       
    },[newPost,fromTemplate,createTemplate,editJobPost,resetDropdown]) 
    // const updateCovidStatus = (data) => {
    //     dispatch(updatecovidVaccination(data.value));
    // };
 //   console.log(covidVaccinationStatus);
//  console.log({vaciine:masterData?.allCovidVaccinatedOption});
    return (
        <div className="card">
            <div className="col-lg-12 col-md-12">
                <div className="row">
                    <div className="card-header">
                        <h3 class="card-title">Covid 19 Vaccination Status</h3>
                    </div>
                    <div className="card-body">
                        <div class="row">
                        {/* <DropDown name={'covidVaccinationStatus'}
                            divClass="col-lg-3 col-md-3"
                            // label={'Shift Length*'}
                            id={'covidVaccinationStatus'}
                            options={masterData?.allCovidVaccinatedOption} multiple={false}
                            value={covidVaccinationStatus ? [covidVaccinationStatus] : []}
                            updateValue={updateCovidStatus} isObject={true}
                            errors={props.errors ? props.errors['covidVaccinationStatus'] : []}
                        /> */}
                         <MultiSelect name={'covidVaccinationStatus'}
                                // divClass="col-lg-4 col-md-4"                               
                                id={'covidVaccinationStatus'}
                                value={covidVaccinationStatus}
                                options={masterData?.allCovidVaccinatedOption} multiple={true}
                                updateValue={updateCovidStatus} isObject={true}                                
                                errors={props.errors ? props.errors['covidVaccinationStatus'] : []}
                                multiselectRef={vaccineRef}
                                divClass={props?.checkWidth}
                            />
                            </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
